import React, {Fragment} from "react";

import {Badge, BadgeVariantsUnionType} from "@pg-design/badge-module";

import * as styles from "./GalleryPicture.module.css";

export interface IGalleryPicture {
    imgAlt?: string;
    onClick: () => void;
    srcSm?: string;
    srcMd?: string;
    srcLg?: string;
    tags?: {
        label: string;
        variant: BadgeVariantsUnionType;
        icon?: (props: {fill: string; className: string; size?: string}) => React.ReactElement;
    }[];
    onLoad?: () => void;
}

export const GalleryPicture = (props: IGalleryPicture) => {
    return (
        <div className={styles.wrapper}>
            {props.tags && (
                <div className={styles.tags}>
                    {props.tags.map((tag, index) => (
                        <Badge variant={tag.variant} icon={tag.icon} iconSize="1.5" key={index}>
                            {tag.label}
                        </Badge>
                    ))}
                </div>
            )}
            <picture className={styles.galleryImageHolder}>
                {props.srcLg && <source media="(min-width: 1920px)" srcSet={props.srcLg} />}
                {props.srcMd && (
                    <Fragment>
                        <source media="(min-width: 1400px)" srcSet={props.srcMd} />
                        <source media="(min-width: 480px)" srcSet={props.srcMd} />
                    </Fragment>
                )}
                {props.srcSm && (
                    <Fragment>
                        <source media="(min-width: 1024px)" srcSet={props.srcSm} />
                        <source media="(min-width: 768px)" srcSet={props.srcSm} />
                    </Fragment>
                )}
                <img src={props.srcSm} alt={props.imgAlt} loading="lazy" onClick={props.onClick} onLoad={props.onLoad} />
            </picture>
        </div>
    );
};
import React, {Fragment} from "react";

import {Badge, BadgeVariantsUnionType} from "@pg-design/badge-module";

import * as styles from "./GalleryPicture.module.css";

export interface IGalleryPicture {
    imgAlt?: string;
    onClick: () => void;
    srcSm?: string;
    srcMd?: string;
    srcLg?: string;
    tags?: {
        label: string;
        variant: BadgeVariantsUnionType;
        icon?: (props: {fill: string; className: string; size?: string}) => React.ReactElement;
    }[];
    onLoad?: () => void;
}

export const GalleryPicture = (props: IGalleryPicture) => {
    return (
        <div className={styles.wrapper}>
            {props.tags && (
                <div className={styles.tags}>
                    {props.tags.map((tag, index) => (
                        <Badge variant={tag.variant} icon={tag.icon} iconSize="1.5" key={index}>
                            {tag.label}
                        </Badge>
                    ))}
                </div>
            )}
            <picture className={styles.galleryImageHolder}>
                {props.srcLg && <source media="(min-width: 1920px)" srcSet={props.srcLg} />}
                {props.srcMd && (
                    <Fragment>
                        <source media="(min-width: 1400px)" srcSet={props.srcMd} />
                        <source media="(min-width: 480px)" srcSet={props.srcMd} />
                    </Fragment>
                )}
                {props.srcSm && (
                    <Fragment>
                        <source media="(min-width: 1024px)" srcSet={props.srcSm} />
                        <source media="(min-width: 768px)" srcSet={props.srcSm} />
                    </Fragment>
                )}
                <img src={props.srcSm} alt={props.imgAlt} loading="lazy" onClick={props.onClick} onLoad={props.onLoad} />
            </picture>
        </div>
    );
};
